import axios from '@/libs/api.request';

export const getSystemSettingList = data => {
    return axios.request({
        url: 'api/systemManagement/systemSetting/getSystemSettingList',
        data: data,
        method: 'post'
    });
};

export const saveSystemSetting = data => {
    return axios.request({
        url: 'api/systemManagement/systemSetting/saveSystemSetting',
        data: data,
        method: 'post'
    });
};

export const systemUpdatePassword = data => {
    return axios.request({
        url: 'api/systemManagement/systemSetting/systemUpdatePassword',
        data: data,
        method: 'post'
    });
};